// Configuration Firebase
// Remplacez les valeurs par celles de votre projet Firebase
// Vous pouvez les trouver dans Firebase Console > Paramètres du projet > Vos applications

import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD5OeA7DrDMKhCiXTs0BilVrHtA9KtLnDo",
  authDomain: "aqua-farina.firebaseapp.com",
  projectId: "aqua-farina",
  storageBucket: "aqua-farina.firebasestorage.app",
  messagingSenderId: "182107743270",
  appId: "1:182107743270:web:af7f56be97c7448bfe72e7",
  measurementId: "G-965RLTBN2J"
};

// Initialiser Firebase seulement s'il n'est pas déjà initialisé
let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

// Initialiser Analytics
let analytics = null;

// Fonction pour initialiser Analytics de manière asynchrone
export const initAnalytics = async () => {
  if (analytics) {
    return analytics;
  }
  
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const supported = await isSupported();
    if (supported) {
      analytics = getAnalytics(app);
      return analytics;
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Firebase Analytics non supporté:', error);
    }
  }
  
  return null;
};

// Initialiser Analytics immédiatement si possible
if (typeof window !== 'undefined') {
  initAnalytics();
}

// Initialiser Auth, Firestore et Storage
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export { app, analytics };


